import { combineReducers } from "redux";
import * as types from "../actions/actionTypes";
import initialState from "./initialState";

import accountHistory from "./accountHistoryReducer";
import appointments from "./appointmentReducer";
import availableDates from "./availableDatesReducer";
import availableHours from "./availableHoursReducer";
import availableServices from "./availableServicesReducer";
import completedDocument from "./completedDocumentReducer";
import devices from "./deviceReducer";
import documents from "./documentsReducer";
import invoice from "./invoiceReducer";
import locations from "./locationsReducer";
import nextPayment from "./nextPaymentReducer";
import notifications from "./notificationReducer";
import paymentMethod from "./paymentMethodReducer";
import profile from "./profileReducer";
import reportSignatures from "./reportSignaturesReducer";
import report from "./reportReducer";
import selectedLanguage from "./languageReducer";
import states, { programTypes } from "./dataListReducer";
import vehicle from "./vehicleReducer";

const appReducer = combineReducers({
  notifications,
  devices,
  profile,
  vehicle,
  appointments,
  nextPayment,
  accountHistory,
  paymentMethod,
  invoice,
  locations,
  availableDates,
  availableHours,
  availableServices,
  reportSignatures,
  documents,
  completedDocument,
  report,
  selectedLanguage,
  states,
  programTypes,
});

const rootReducer = (state, action) => {
  if (
    action.type === types.USER_LOGIN_SUCCESS ||
    action.type === types.USER_LOGOUT_SUCCESS
  ) {
    // state = [{ CurrentState: "Undefined" }];
    state = initialState;
  }
  return appReducer(state, action);
};

export default rootReducer;
